import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g id=\"receiptEuro\"><g id=\"Group 548\"><path id=\"Vector\" d=\"M4 2V22L6 21L8 22L10 21L12 22L14 21L16 22L18 21L20 22V2L18 3L16 2L14 3L12 2L10 3L8 2L6 3L4 2Z\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Vector_2\" d=\"M8 12H13\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Vector_3\" d=\"M15.9999 9.50001C15.4685 8.87864 14.7593 8.43508 13.9681 8.22906C13.1768 8.02304 12.3414 8.06446 11.5744 8.34774C10.8074 8.63103 10.1456 9.14256 9.67818 9.81345C9.21078 10.4843 8.96021 11.2824 8.96021 12.1C8.96021 12.9177 9.21078 13.7157 9.67818 14.3866C10.1456 15.0575 10.8074 15.569 11.5744 15.8523C12.3414 16.1356 13.1768 16.177 13.9681 15.971C14.7593 15.7649 15.4685 15.3214 15.9999 14.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }